import { RequestHelper } from "../RequestHelper";
import { AxLoad } from "../../AxSystem/AxLoad";
import { AxStaticConfigModule } from "../../../Modules/AxConfig/AxStaticConfigModule";

export class SummaryRedirect {
    constructor(private _requestHelper = new RequestHelper()) {}

    redirect(postURL: string, data: any, timeSlots: boolean) {
        let configModule = AxLoad.GetModule<AxStaticConfigModule>('AxStaticConfigModule');

        if (configModule.skipSummary) {
            AxessViewer.loadPartialView(postURL, data, (result) => {
                AxLoad.LoadModule('AxFireShoppingCartModal', {
                    result: result,
                    continueShoppingPath: "Tickets",
                    btn: '.tv4_prod-selection__addToCart-submit',
                    ResetQuantity: false,
                    queryAddition: timeSlots ? '?ref=pit' : '?ref=pi'
            });
            }, {
                silent: true,
                skipShoppingCartReload: false,
                addCulturInfo: false
            });

            return;
        }

        this._requestHelper.postToUrl(postURL, data, {});
    }
}